/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-03-22 10:26:57
 * @LastEditors Please set LastEditors
 * @LastEditTime 2024-05-30 17:05
 * @FilePath: /locationpms-pc/config/env.js
 * @Description: 各环境请求域名
 * 
 *  
 */

const env = process.env.npm_config_env;
let targetUrl = "";
let targetUrl2 = "";
let crmUrl = "";

// 非要连本地
// targetUrl = 'http://10.10.20.194:8080/';
let orgUrl = "https://ie-orm.lanhanba.net/"; // 组织管理url
// 低代码请求url
// const legoRequestUrl = 'https://lego.lanhanba.net';
// const legoRequestUrl = 'http://10.10.20.24:8080';
// 默认代理到 测试环境
if (!env || env === 'IE') { // 集成
  targetUrl = 'https://iepmspc.lanhanba.net/';
  targetUrl2 = 'https://ie-erp.lanhanba.net';
  crmUrl = 'https://ie-wkcrm.lanhanba.net';
  orgUrl = "https://ie-orm.lanhanba.net/";
  webUrl = "https://iepmsweb.lanhanba.net";
} else if (env === 'TE') { // 测试
  targetUrl = 'https://pms.lanhanba.net/';
  targetUrl2 = 'https://erp.lanhanba.net';
  crmUrl = 'https://wkcrm.lanhanba.net';
  orgUrl = "https://orm.lanhanba.net/";
  webUrl = "https://pmsweb.lanhanba.net";
} else if (env === 'SE') { // 预演
  targetUrl = 'https://pms.lanhanba.com/';
  targetUrl2 = 'https://erp.lanhanba.com';
  crmUrl = 'https://se-crm.locxx.com';
  orgUrl = "https://orm.lanhanba.com/";
  webUrl = "https://pmsweb.lanhanba.com";
} else if (env === 'PE') { // 生产
  targetUrl = 'https://pms.locxx.com/';
  targetUrl2 = 'https://erp.location.pub/';
  crmUrl = 'http://location-crm.location.pub';
  orgUrl = "https://orm.location.pub/";
  webUrl = "https://newpmsweb.location.pub";
}

module.exports = {
  env,
  targetUrl,
  targetUrl2,
  crmUrl,
  orgUrl,
  webUrl
}